import {
  createPromiseAction,
  rejectPromiseAction,
  resolvePromiseAction,
} from 'redux-saga-promise-actions'
import { call, put, takeEvery } from 'redux-saga/effects'
import { profileAvatarAPI } from '../../../api'
import { userData } from 'features/user/store'
import {
  PROFILE_AVATAR_UPLOAD_REQUEST,
  PROFILE_AVATAR_UPLOAD_SUCCESS,
  PROFILE_AVATAR_UPLOAD_FAILED,
} from './actionTypes'

export const profileAvatarUploadPA = createPromiseAction(
  PROFILE_AVATAR_UPLOAD_REQUEST,
  PROFILE_AVATAR_UPLOAD_SUCCESS,
  PROFILE_AVATAR_UPLOAD_FAILED
)()

function* upload(action) {
  try {
    const response = yield call(profileAvatarAPI.uploadAvatar, action.payload)
    const { data } = response

    yield put(profileAvatarUploadPA.success({}))

    yield put(userData.updateData({ avatar: data.data }))

    resolvePromiseAction(action, {})
  } catch (error) {
    if (!error.response) {
      throw error
    }
    rejectPromiseAction(action, error.response.data)
  }
}

export function* uploadSaga() {
  yield takeEvery(profileAvatarUploadPA.request, upload)
}
